import enLocale from "element-ui/lib/locale/lang/en";

export default {
  ...enLocale,

  energyExchange: "Resource exchange",
  Aboutus: "About us",
  FAQ: "FAQ",
  Support: "Support",
  Switchlanguage: "Switch language",
  tips1: "Transfer Times Purchase",
  tips2: "Reasonable price, real-time transfer",
  tips3:
    "The website has been restored, the billing address has been changed, and the old address is invalid!",
  tips4: "Instructions",
  tips5: "Please use decentralized wallet to rent energy.",
  tips6:
    "Based on the rental demand for energy, the system accountant calculates the total amount of exchange and the amount to be paid. Only TRX payment is supported.",
  tips7:
    "After payment, the platform will distribute the corresponding energy to your receiving account.",
  tips8:
    "Advocate for on-demand leasing, use up before renting! Unlimited number of times per day!",
  tips9: "About Energy Infinite",
  Economic: "Economic",

  SAFE: "Safe",
  EFFICIENT: "Efficient",

  tips10:
    "The Energy Infinite platform is an energy exchange platform in wave field ecology. Our goal is to reduce the TRX fee required for wave traders to consume energy. The exchange process is simple and fast, with a favorable price. We provide you with a safer and more efficient energy exchange service 24 hours a day.",

  tips11: "Solve the problem of excessive TRX fees",

  tips12: "Fast and convenient",
  tips13: "Applicable to USDT, contract transfer, etc",
  tips14: "Money Saving Expert for Tron Users",
  tips15: "FAQ",
  tips16: "How to purchase number of times",

  tips17:
    "Please click on redeem resource and fill in the purchase information at the top of this page, and then follow the prompts to transfer the corresponding TRX to the platform account.",
  tips18: "When will the energy arrive?",
  tips19:
    "After the payment is completed,the energy will be received within 6 second. In rare cases, there will be a delay of 30 to 60 seconds.",
  tips20: "How many orders can I have at the same time?",
  tips21:
    "Multiple purchases can be made under the same address, with no limits.",
  tips22: "Can I withdraw my order?",

  tips23: "The order does not support withdrawal.",

  Paymentaddress: "Payment address",
  Receivingaddress: "Receiving address",
  Keywords: "payAddress / receiveAddress / txHash",
  Rentingenergy: "Renting energy",
  RentingBandwidth: "Renting bandwidth",
  resourceType: "Resource type",
  price: "Price",
  pleaseSelect: "Please select",
  Createorder: "Create order",
  cancel: "Cancel",
  OnlineService: "Online Service",
  tips24: "Serving you wholeheartedly",
  tips25: "Click to copy",
  pleaseInput: "Please input",
  tips26: "Please enter a valid number greater than 0",
  tips27: "Order creation failed, please try again later!",
  day: "day",
  minute: "minute",
  hour: "hour",
  unitprice: "unit-price",
  confirm: "confirm",
  prompt: "prompt",
  replicatingSuccess: "Replicating Success!",
  tips28: "Remaining energy of the platform",
  tips28Bandwidth: "Remaining bandwidth of the platform",
  tips29: "Platform billing address",
  tips30: "View payment QR code",
  QRcode: "QR code",
  save: "Save",
  tips31: "Latest Transaction",
  rechargeHistory: "Recharge History",
  recharge: "Recharge",
  confirmRecharge:'Confirm recharge',
  rechargeBalance: "Recharge balance",
  Users: "Users",
  ExchangeType: "Exchange Type",
  Amount: "Amount",
  searchKey: "Please enter search keywords",
  search: "Search",
  tips32: "Receiving record query failed, please try again later!",
  500: "system error",
  400: "parameter error",
  10001: "wrong username or password",
  10002: "please log in first",
  20001: "address has been added, please do not add it again",
  20002: "please grant energy leasing authorization first",
  20003: "Insufficient resources, please try again later",
  20004: "bad address",
  20005: "gold owner does not exist",
  20006: "weight setting of the gold master is incorrect",
  20007: "Order is not actionable",
  20008: "Order payment does not exist",
  20009: "Insufficient energy/bandwidth in the gold wallet",
  20010: "qr code generation failed",
  20011: "insufficient balance",
  20012: "enterprise not found",
  20013: "please enter pay address",
  20014: "The key is incorrect",
  20015: "Unable to reset administrator password",
  20016: "Unable to reset administrator status",
  20017: "Delegate failed",
  20018: "Address book has reached the maximum limit",
  20019: "Address cannot be added repeatedly",
  20020: "Repeated data",
  20021: "User not exist",
  20022: "Gold master binding limit reached",
  20023: "Monitor address count limit reached",
  10017:
    "Please enter a password consisting of 6 to 16 digits in length, including numbers and letters",
  10018: "Payment address mismatch",
  10019: "Payment amount mismatch",
  10020: "Missing enterprise payment ID",
  10021: "Transaction duplicate binding",
  10024: "energy is insufficient. Please try again later",
  90001:
    "very sorry, service maintenance is in progress. please try again later",

  10022:'Username already exists',
  tips: "prompt",
  Copyaddress: "Copy address",
  tips33: "Energy Infinite Exchange Platform",
  tips34: "65000 energy can be converted into one account.",
  tips34Bandwidth: "280 bandwidth can be converted into one account.",
  tips35: "Please enter an integer",
  tips36: "Energy distribution in progress, please wait......",
  tips37:'Two passwords are inconsistent',
  tips38:'Password changed successfully, please log in again',
  referralCode: "Referral code",
  EnterprisePayKey: "Enterprise payment key",
  EnterprisePayId: "Enterprise payment Id",

  rent: "Rent",
  only: "Only",
  energy: "energy",
  bandwidth: "bandwidth",
  currentPriceEffective: "Effective Now",
  timeRangeSetting: "Time Range",
  Transactioncount: "Transaction count",
  Completepayment: "Complete payment",
  Enterpriseuser: "Enterprise user",
  Ordinaryuser: "Ordinary user",
  TxHash: "txHash",
  PromitBalance: "Your current balance is",
  AccountBalance: "Account balance",
  login:'Login',
  userName:'Username',
  password:'Password',
  noAccount:'No account?',
  register:'Sign up now',
  signUp:'Sign up',
  confirmPassword:'Confirm password',
  orderNo: 'Order No',
  OrderState:"Order state",
  createTime: 'Create time',
  balanceRecharge: 'Balance recharge',
  logOut:'Log out',
  editPw:'Edit password',
  oldPw:'Old password',
  newPw:'New password',
  PersonalInformation:'User information',
  ProxyTxId: "Proxy TxId",
  noEnterprisePrice: "There is currently no enterprise price available. Please contact customer service to add it",
  addressBook: 'Address Book',
  address: 'Address',
  operations: 'Operations',
  delete: 'Delete',
  add: 'Add',
  pleaseInputAddress: 'Please input address',
  addSuccess: 'Added successfully',
  deleteSuccess: 'Deleted successfully', 
  confirmDelete: 'Are you sure to delete this address?',
  monitorAddress: 'Monitor Address',
  monitorAddressBook: 'Monitor Address Book',
  setMonitorInterval: 'Set Monitor Interval',
  monitorInterval: 'Monitor Interval',
  oneHour: '1 Hour',
  threeHours: '3 Hours',
  sixHours: '6 Hours',
  twelveHours: '12 Hours',
  twentyFourHours: '24 Hours',
  platformReceiveAddress: 'Platform Receive Address',
  noExclusiveAddress: 'No Exclusive Address',
  noExclusiveAddressTip: 'You have not activated the exclusive recharge address function. Please contact customer service or use the function below to create a general recharge order',
  hasExclusiveAddress: 'Exclusive Address Configured',
  yourExclusiveAddress: 'Your exclusive recharge address is',
  exclusiveAddressTip: 'You can directly transfer TRX and wait for about 10 seconds to complete automatic credit',
  canStillUseGeneral: 'You can still use the function below to create a general recharge order',
  generalRechargeNotice: 'General recharge orders require payment address and recharge amount to match. If entered incorrectly, please contact customer service for verification and manual credit',
  notice: 'Notice',
  refresh: 'Refresh',
  refreshSuccess: 'Refresh successful',
  refreshFailed: 'Refresh failed',
  copy: 'Copy',
  serverError: 'Server error, please try again later',
  energyThreshold: "Energy Threshold",
  pleaseInputEnergyThreshold: "Please input energy threshold",
  energyThresholdMustBeNumber: "Energy threshold must be a number",
  energyThresholdRange: "Energy threshold range 0-100000000",
  monitorThreshold: "Monitor Threshold",
  pleaseInputMonitorThreshold: "Please input monitor threshold",
  monitorThresholdMustBeNumber: "Monitor threshold must be a number",
  monitorThresholdRange: "Monitor threshold range 0-100000000",
  pleaseInputBandwidthThreshold: "Please input bandwidth threshold",
  rentalAmount: "Rental Amount",
  pleaseInputRentalAmount: "Please input rental amount",
  rentalAmountMustBeNumber: "Rental amount must be a number",
  rentalAmountRange: "Rental amount range 100-1000000000",
  pleaseInputBandwidthAmount: "Please input bandwidth rental amount",
  pleaseInputEnergyAmount: "Please input energy rental amount",
  monitorPriceTypeMismatch: "Selected price does not match resource type",
  balanceNotifyThreshold: "Balance Notify Threshold",
  balanceNotifyInterval: "Notification Interval",
  seconds: "Seconds",
  valueRangeError: "Value must be between 0 and 10,000,000",
  saveSuccess: "Saved successfully",
  saveFailed: "Save failed",
  never: "Never",
  tenMinutes: "10 minutes",
  thirtyMinutes: "30 minutes",
  twelveHours: "12 hours",
  oneDay: "1 day",
  sevenDays: "7 days",
  bandwidthMinTip: "Bandwidth rental cannot be less than {amount}",
  bandwidthPresetMin: "5,000",
  bandwidthPreset20: "5,600(20 transfers)",
  bandwidthPreset40: "11,200(40 transfers)",
  bandwidthAmountTooSmall: "Bandwidth order cannot be less than {amount}",
  bandwidthAmountStepTip: "Recommended to input in multiples of 280 bandwidth/transfer (20 transfers=5,600, 40 transfers=11,200)"
};



// WEBPACK FOOTER //
// ./src/i18n/en.js